import styles from "./styles.module.scss";

import body from "./img/body.png";
import dish from "./img/dish.png";
import fire from "./img/fire.png";
import happy from "./img/happy.png";
import thumb from "./img/thumb.png";

const DATA = [
  {
    img: fire,
    text: "Toned body: shape up naturally through walking",
  },
  {
    img: body,
    text: "10-min interval walks designed for your personal goals",
  },
  {
    img: thumb,
    text: "Stress relief: reduce tension and clear your mind while moving",
  },
  {
    img: happy,
    text: "100+ walking variations to boost cardio and mobility",
  },
  {
    img: dish,
    text: "Daily custom program to keep you on track",
  },
];

export const Benefits = () => {
  return (
    <div className={styles.benefits}>
      <p className={styles.title}>Highlights of your plan</p>
      <div className={styles.list}>
        {DATA.map(({ img, text }, index) => (
          <div key={index} className={styles.listItem}>
            <div className={styles.icon}>
              <img src={img} />
            </div>
            <p>{text}</p>
          </div>
        ))}
      </div>
      <p className={styles.disclaimer}>
        Disclaimer: For the best results, stay consistent with your walking
        program and maintain a balanced diet. Please consult a healthcare
        professional before starting any exercise routine.
      </p>
    </div>
  );
};
